import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-infinite-carousel',
  templateUrl: './infinite-carousel.component.html',
  styleUrls: ['./infinite-carousel.component.css']
})
export class InfiniteCarouselComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
